// This component is for the submenus on Mobile

import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FaAngleDown, FaAngleRight } from "react-icons/fa";

const ExpandMenu = ({ route, toggleDrawer }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeRoute, setActiveRoute] = useState("");

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleRouteClick = (link) => {
    setActiveRoute(link);
    toggleDrawer();
  };

  return (
    <SMenu>
      <MenuButton onClick={toggleMenu}>
        {route.name} {isMenuOpen ? <FaAngleDown /> : <FaAngleRight />}
      </MenuButton>
      <SubRoutesContainer isOpen={isMenuOpen}>
        {route.subRoutes.map((subRoute) => (
          <SubRoute
            to={subRoute.link}
            key={subRoute.name}
            target={subRoute.newTab ? "_blank" : undefined}
            rel={subRoute.newTab ? "noopener noreferrer" : undefined}
            isActive={activeRoute === subRoute.link}
            onClick={() => handleRouteClick(subRoute.link)} // Close drawer on click
          >
            {subRoute.name}
          </SubRoute>
        ))}
      </SubRoutesContainer>
    </SMenu>
  );
};


export default ExpandMenu;

const SubRoutesContainer = styled.div`
  display: ${(props) => (props.isOpen ? "flex" : "none")};
  flex-direction: column;
  padding: 1rem;
`;
const SMenu = styled.div`
`;

const MenuButton = styled.div`
  font-size: 20px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

const SubRoute = styled(Link)`
  text-decoration: none;
  color: black;
  padding: 15px;
  font-size: 20px;
`;
